<template>
  <div class="home">
    <h4>This is a home page</h4>
  </div>
</template>